<template>
  <div>
    <!-- مودال اصلی دانلود گروهی -->
         <custom-popup
      v-model="internalValue"
      :cons="{ title: 'دانلود گروهی کیوآر کد: ', icon: 'download' }"
      max-width="650"
      hide-confirm
      @close="closeModal"
    >

      <v-card class="rounded-xl overflow-hidden">
        <v-card-text class="pa-5">
          <!-- نوار وضعیت تعداد آیتم‌ها -->
          <v-alert
            dense
            text
            type="info"
            class="mb-6 rounded-lg font-weight-medium"
          >
            تعداد آیتم‌های انتخاب شده برای دانلود: <strong>{{ validItems.length }}</strong> عدد
          </v-alert>

          <!-- ردیف آیکون‌ها، راهنما و دکمه تنظیمات -->
          <v-row class="my-3 custom-icons-row" justify="center" align="center" no-gutters>
            
            <!-- دکمه راهنمای فرمت‌ها -->
            <div class="guide-btn-wrapper mr-2" @click="showGuideDialog = true">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="info" v-bind="attrs" v-on="on" class="guide-btn elevation-2">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>راهنمای انتخاب فرمت مناسب</span>
              </v-tooltip>
            </div>

            <!-- آیکون‌های فرمت با قابلیت دانلود سریع با کلیک -->
            <v-tooltip
              top
              v-for="item in multipleType"
              :key="item.value"
              color="dark"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="custom-file-icon mx-1"
                  :class="{ 'selected-icon': qrType === item.value }"
                  v-bind="attrs"
                  v-on="on"
                  @click="quickBulkDownload(item.value)"
                >
                  <img
                    :src="`/media/download/${item.value}.webp`"
                    :alt="`دانلود زیپ ${item.text}`"
                    class="file-icon-img"
                    @error="onImgError"
                  />
                </div>
              </template>
              <div class="text-center">
                <strong>{{ item.text }} (دانلود گروهی)</strong>
                <div class="caption mt-1">{{ item.desc }}</div>
              </div>
            </v-tooltip>

            <!-- دکمه باز/بستن تنظیمات پیشرفته با انیمیشن چرخش -->
            <div class="settings-btn-wrapper ml-2" @click="showAdvanced = !showAdvanced">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    class="settings-icon-box"
                    :class="{ 'active-settings': showAdvanced }"
                  >
                    <v-icon size="26" :color="showAdvanced ? 'white' : '#757575'">
                      {{ showAdvanced ? 'mdi-close' : 'mdi-tune' }}
                    </v-icon>
                  </div>
                </template>
                <span>{{ showAdvanced ? 'بستن تنظیمات' : 'تنظیمات پیشرفته سایز و کیفیت' }}</span>
              </v-tooltip>
            </div>
          </v-row>

          <!-- پنل کشویی تنظیمات پیشرفته -->
          <v-expand-transition>
            <div v-show="showAdvanced" class="advanced-settings-box pa-5 my-4 rounded-xl">
              <v-row dense>
                <!-- انتخاب فرمت -->
                <v-col class="pa-2" cols="12" :md="(computedFormat === 'dxf' || computedFormat === 'eps') ? '4' : '6'">
                  <v-autocomplete
                    v-model="qrType"
                    :items="types"
                    append-icon="mdi-image-outline"
                    dense
                    outlined
                    label="فرمت فایل خروجی"
                    hide-details
                    :disabled="loading"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                        <v-list-item-subtitle class="text-caption text-grey" v-if="item.desc" v-text="item.desc"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- انتخاب سایز -->
                <v-col class="pa-2" cols="12" :md="(computedFormat === 'dxf' || computedFormat === 'eps') ? '4' : '6'">
                  <v-autocomplete
                    v-model="qrSize"
                    :items="sizes"
                    append-icon="mdi-format-list-bulleted-type"
                    dense
                    outlined
                    label="رزولوشن و ابعاد تصویر"
                    hide-details
                    :disabled="loading"
                  />
                </v-col>

                <!-- انتخاب تراکم برای DXF / EPS -->
                <v-col v-if="computedFormat === 'dxf' || computedFormat === 'eps'" class="pa-2" cols="12" md="4">
                  <v-autocomplete
                    v-model="pixel_c"
                    :items="CountPixels"
                    append-icon="mdi-dots-grid"
                    dense
                    outlined
                    label="تراکم (کیفیت)"
                    hide-details
                    :disabled="loading"
                  ></v-autocomplete>
                </v-col>

                <!-- دکمه اعمال و دانلود از داخل تنظیمات -->
                <v-col class="pa-2 mt-3" cols="12">
                  <v-btn
                    :loading="loading"
                    class="btn-download rounded-lg w-100"
                    
                    block
                    large
                    @click="startProcess"
                  >
                    <v-icon class="me-2">mdi-cloud-download</v-icon>
                    شروع دانلود زیپ با تنظیمات انتخاب‌شده
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <!-- پروگرس‌بار پردازش زیپ -->
          <div v-if="loading" class="mt-4 pa-3 bg-light rounded-lg">
            <div class="d-flex justify-space-between mb-2 text-caption font-weight-bold">
              <span>در حال تبدیل و آماده‌سازی فایل زیپ ({{ computedFormat.toUpperCase() }})...</span>
              <span>{{ processedCount }} از {{ validItems.length }}</span>
            </div>
            <v-progress-linear
              :value="progressPercent"
              color="success"
              height="10"
              rounded
              striped
            ></v-progress-linear>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <!-- فوتر مودال -->
        <v-card-actions class="px-5 py-3 bg-grey-lighten-5">
          <v-btn class="btn-delete" @click="closeModal" :disabled="loading"><v-icon>mdi-close</v-icon>انصراف</v-btn>
         <v-spacer/>
          <v-btn
            v-if="!showAdvanced"
            :loading="loading"
            class="btn-download rounded-lg"
            :disabled="!validItems.length"
            @click="startProcess"
          >
            <v-icon left small>mdi-download</v-icon>
            دانلود زیپ ({{ computedFormat.toUpperCase() }})
          </v-btn>
        </v-card-actions>
      </v-card>
      </custom-popup>


    <!-- مدال راهنمای فرمت‌ها -->
                <custom-popup
              v-model="showGuideDialog"
              :cons="{title:'راهنمای انتخاب فرمت مناسب',icon:'information-outline'}"
              hide-confirm
              max-width="700"
              scrollable
              @close="showGuideDialog = false"
            >

      <v-card class="rounded-xl pa-2">
        <v-card-text class="pa-4">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="bg-grey-lighten-4">
                  <th class="text-right font-bold">فرمت</th>
                  <th class="text-right">بهترین کاربرد</th>
                  <th class="text-right">نکته مهم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in formatsGuide" :key="item.name">
                  <td class="font-weight-bold text-primary">{{ item.name }}</td>
                  <td>{{ item.usage }}</td>
                  <td class="text-caption text-grey-darken-2">{{ item.note }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="pa-4 bg-grey-lighten-5 justify-end">
          <v-btn  class="btn-get-code rounded-lg px-6" @click="showGuideDialog = false">
            متوجه شدم
          </v-btn>
        </v-card-actions>
      </v-card>
      </custom-popup>
  </div>
</template>

<script>
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { writePsd } from "ag-psd";
import Drawing from "dxf-writer";

export default {
  name: "BulkDownloadQrModal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    zipPrefix: {
      type: String,
      default: "qrcodes"
    }
  },
  data() {
    return {
      showAdvanced: false,
      showGuideDialog: false,
      loading: false,
      processedCount: 0,
      
      qrType: "png",
      qrSize: "1024",
      pixel_c: "1",

      CountPixels: [
        { text: "۱۰۰٪ (بیشترین تراکم - بالاترین کیفیت)", value: "1" },
        { text: "۹۰٪", value: "2" },
        { text: "۸۰٪", value: "3" },
        { text: "۷۰٪", value: "4" },
        { text: "۶۰٪", value: "5" },
        { text: "۵۰٪ (تراکم متوسط)", value: "6" },
        { text: "۴۰٪", value: "7" },
        { text: "۳۰٪", value: "8" },
        { text: "۲۰٪", value: "9" },
        { text: "۱۰٪ (کمترین تراکم - سبک‌ترین فایل)", value: "10" }
      ],

      types: [
        { text: "SVG", value: "svg", desc: "بدون افت کیفیت، عالی برای چاپ بنر و کارت ویزیت" },
        { text: "PNG", value: "png", desc: "کیفیت بالا با پس‌زمینه شفاف، مناسب سایت و سوشال مدیا" },
        { text: "JPEG", value: "jpeg", desc: "حجم مناسب، سازگار با تمام دستگاه‌ها (بدون پس‌زمینه شفاف)" },
        { text: "WEBP", value: "webp", desc: "حجم بسیار کم، مناسب برای لود سریع در وب‌سایت‌ها" },
        { text: "PSD", value: "psd", desc: "فایل لایه‌باز برای استفاده مستقیم در نرم‌افزار فتوشاپ" },
        { text: "DXF", value: "dxf", desc: "فرمت برداری برای دستگاه‌های برش لیزر و حکاکی CNC" },
        { text: "EPS", value: "eps", desc: "فرمت برداری استاندارد برای چاپخانه‌ها و ایلاستریتور" }
      ],

      formatsGuide: [
        { name: "SVG", usage: "چاپ کارت ویزیت، بنر، تراکت و نمایش در سایت", note: "بهترین انتخاب عمومی. بدون افت کیفیت بزرگ می‌شود و پس‌زمینه شفاف دارد." },
        { name: "PNG", usage: "سایت، شبکه‌های اجتماعی، فایل‌های اداری (Word)", note: "شفافیت دارد و لبه‌های QR واضح است. با بزرگ‌کردن بیش از حد پیکسلی می‌شود." },
        { name: "JPEG", usage: "سامانه‌هایی که فقط JPG قبول می‌کنند", note: "شفافیت ندارد. پس‌زمینه سفید اعمال می‌شود." },
        { name: "WEBP", usage: "فروشگاه‌های اینترنتی و وب‌سایت‌ها", note: "حجم بسیار کم و پشتیبانی از شفافیت. برای چاپ مناسب نیست." },
        { name: "PSD", usage: "تحویل به طراح گرافیک", note: "جهت استفاده مستقیم داخل پروژه‌های فتوشاپ." },
        { name: "DXF", usage: "حکاکی CNC، برش لیزر و اتوکد", note: "پیکسل‌ها را به مختصات هندسی تبدیل می‌کند." },
        { name: "EPS", usage: "تحویل به چاپخانه‌ها", note: "قالب رایج برداری در فرایندهای چاپ صنعتی." }
      ]
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    validItems() {
      return (this.items || []).filter(i => i && (i.img_url || i.image));
    },
    multipleType() {
      return this.types;
    },
    computedFormat() {
      return this.qrType;
    },
    sizes() {
      return [
        { text: "512x512 px (سبک)", value: "512" },
        { text: "1024x1024 px (استاندارد)", value: "1024" },
        { text: "2048x2048 px (کیفیت چاپ عالی)", value: "2048" },
        { text: "4000x4000 px (رزولوشن فوق‌العاده بالا)", value: "4000" }
      ];
    },
    progressPercent() {
      if (!this.validItems.length) return 0;
      return Math.round((this.processedCount / this.validItems.length) * 100);
    }
  },
  methods: {
    onImgError(e) {
      e.target.style.display = "none";
    },
    closeModal() {
      if (this.loading) return;
      this.internalValue = false;
      this.processedCount = 0;
      this.showAdvanced = false;
    },

    // کلیک مستقیم روی هر آیکون فرمت
    async quickBulkDownload(format) {
      this.qrType = format;
      await this.startProcess();
    },

    // ایجاد بافر PSD
    async createPsdBuffer(canvas) {
      const psd = {
        width: canvas.width,
        height: canvas.height,
        children: [{ name: "QR Code", canvas: canvas }]
      };
      const buffer = writePsd(psd);
      return new Blob([buffer], { type: "application/octet-stream" });
    },

    // ایجاد رشته DXF
    async createDxfBlob(canvas, size) {
      const d = new Drawing();
      d.setUnits("Pixels");
      const ctx = canvas.getContext("2d");
      const imgData = ctx.getImageData(0, 0, size, size);
      const data = imgData.data;
      const step = parseInt(this.pixel_c) || 1;

      for (let y = 0; y < size; y += step) {
        for (let x = 0; x < size; x += step) {
          const index = (y * size + x) * 4;
          const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3];
          if (a > 128 && (r + g + b) / 3 < 128) {
            d.drawRect(x, -y, x + step, -(y + step));
          }
        }
      }
      return new Blob([d.toDxfString()], { type: "application/dxf" });
    },

    // ایجاد رشته EPS
    async createEpsBlob(canvas, size) {
      const ctx = canvas.getContext("2d");
      const imgData = ctx.getImageData(0, 0, size, size);
      const data = imgData.data;
      const step = parseInt(this.pixel_c) || 1;

      let epsString = "%!PS-Adobe-3.0 EPSF-3.0\n";
      epsString += `%%BoundingBox: 0 0 ${size} ${size}\n%%Creator: Qrland\n%%EndComments\n`;
      epsString += `/box { newpath moveto ${step} 0 rlineto 0 ${step} rlineto -${step} 0 rlineto closepath fill } bind def\n`;
      
      let lastColor = null;
      for (let y = 0; y < size; y += step) {
        for (let x = 0; x < size; x += step) {
          const index = (y * size + x) * 4;
          const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3];
          if (a > 128 && (r < 250 || g < 250 || b < 250)) {
            const psR = (r / 255).toFixed(3), psG = (g / 255).toFixed(3), psB = (b / 255).toFixed(3);
            const currentColor = `${psR} ${psG} ${psB}`;
            if (currentColor !== lastColor) {
              epsString += `${currentColor} setrgbcolor\n`;
              lastColor = currentColor;
            }
            const epsY = size - y - step;
            epsString += `${x} ${epsY} box\n`;
          }
        }
      }
      epsString += "%%EOF\n";
      return new Blob([epsString], { type: "application/postscript" });
    },

    // تبدیل متن SVG به فرمت هدف
    async convertSvgToTarget(svgText, targetFormat, size) {
      if (targetFormat === "svg") {
        let text = svgText;
        text = text.replace(/<svg([^>]*)width="[^"]*"([^>]*)>/, `<svg$1$2>`);
        text = text.replace(/<svg([^>]*)height="[^"]*"([^>]*)>/, `<svg$1$2>`);
        text = text.replace(/<svg([^>]*)>/, `<svg$1 width="${size}" height="${size}">`);
        return new Blob([text], { type: "image/svg+xml" });
      }

      return new Promise((resolve, reject) => {
        const img = new Image();
        const svgBase64 =
          "data:image/svg+xml;charset=utf-8;base64," +
          btoa(unescape(encodeURIComponent(svgText)));

        img.onload = async () => {
          const canvas = document.createElement("canvas");
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext("2d");

          if (targetFormat === "jpeg" || targetFormat === "jpg") {
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, size, size);
          }

          ctx.drawImage(img, 0, 0, size, size);

          try {
            if (targetFormat === "psd") {
              const blob = await this.createPsdBuffer(canvas);
              resolve(blob);
            } else if (targetFormat === "dxf") {
              const blob = await this.createDxfBlob(canvas, size);
              resolve(blob);
            } else if (targetFormat === "eps") {
              const blob = await this.createEpsBlob(canvas, size);
              resolve(blob);
            } else {
              canvas.toBlob(
                blob => (blob ? resolve(blob) : reject(new Error("Canvas blob error"))),
                `image/${targetFormat === "jpg" ? "jpeg" : targetFormat}`,
                0.95
              );
            }
          } catch (err) {
            reject(err);
          }
        };

        img.onerror = e => reject(e);
        img.src = svgBase64;
      });
    },

    // پروسه دانلود زیپ
    async startProcess() {
      if (!this.validItems.length) {
        if (this.$toast) this.$toast.warning("هیچ بارکد معتبری برای دانلود یافت نشد");
        return;
      }

      this.loading = true;
      this.processedCount = 0;

      const format = this.computedFormat;
      const size = Number(this.qrSize) || 1024;
      const zip = new JSZip();
      const folder = zip.folder(`${this.zipPrefix}-${format}`);
      const counts = {};

      try {
        const tasks = this.validItems.map(async item => {
          let url = item.img_url || item.image;
          if (url.startsWith("//")) url = "https:" + url;
          else if (url.startsWith("/")) url = `https://cdn.terminalads.com${url}`;

          let safeTitle = (item.title || item.identifier || `qr-${item.id}`)
            .toString()
            .replace(/[\\/:*?"<>|]/g, "_")
            .trim();

          if (counts[safeTitle]) {
            counts[safeTitle]++;
            safeTitle = `${safeTitle}_(${counts[safeTitle] - 1})`;
          } else {
            counts[safeTitle] = 1;
          }

          try {
            const res = await fetch(url);
            if (!res.ok) throw new Error("Fetch error");
            const svgContent = await res.text();

            const fileBlob = await this.convertSvgToTarget(svgContent, format, size);
            const ext = format === "jpeg" ? "jpg" : format;
            folder.file(`${safeTitle}.${ext}`, fileBlob);
          } catch (err) {
            console.warn(`خطا در دریافت ${safeTitle}:`, err);
          } finally {
            this.processedCount++;
          }
        });

        await Promise.all(tasks);

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const dateStr = new Date().toISOString().slice(0, 10);
        saveAs(zipBlob, `${this.zipPrefix}-${format}-${dateStr}.zip`);

        if (this.$toast) this.$toast.success("فایل زیپ با موفقیت ساخته و دانلود شد");
        this.closeModal();
      } catch (error) {
        console.error("Bulk zip error:", error);
        if (this.$toast) this.$toast.error("خطا در ایجاد فایل زیپ");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* کانتینر آیکون‌ها */
.custom-icons-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid #edf2f7;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

/* باکس دکمه‌های آیکون فرمت */
.custom-file-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #f8f9fa;
  border-radius: 14px;
  border: 2px solid #edf2f7;
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.custom-file-icon:hover {
  transform: translateY(-4px) scale(1.06);
  background: #ffffff;
  border-color: var(--v-primary-base, #1976D2);
  box-shadow: 0 6px 14px rgba(25, 118, 210, 0.16);
}

.custom-file-icon.selected-icon {
  border-color: var(--v-primary-base, #1976D2);
  background: #eef6ff;
}

.file-icon-img {
  width: 85%;
  height: auto;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
}

/* دکمه راهنما */
.guide-btn {
  background-color: #f0f7ff !important;
}
.guide-btn:hover {
  background-color: #e0f0ff !important;
}

/* دکمه تنظیمات چرخشی */
.settings-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.settings-icon-box {
  width: 50px;
  height: 50px;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
}

.settings-icon-box:hover {
  border-color: var(--v-primary-base, #1976D2);
  background-color: #e3f2fd;
}

.settings-icon-box.active-settings {
  background-color: #ff4d4f !important;
  border-color: #ff4d4f !important;
  transform: rotate(90deg);
}

/* جعبه کشویی تنظیمات */
.advanced-settings-box {
  background-color: #fcfcfc;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  position: relative;
}

.bg-light {
  background-color: #f8fafc;
}
</style>
